import { PriceIncrement } from '@src/components/Ladder/PriceIncrement';
import { TourName } from '@src/tokens/tours';
import { ButtonVariants, FormControlSizes, HStack, ToggleGroup, Tour, type ToggleGroupOption } from '@talos/kyoko';
import { PriceGridLadderType, type PriceGridLadderType as PriceGridLadderTypeValue } from './ladder';

const LADDER_TYPE_OPTIONS: ToggleGroupOption<PriceGridLadderTypeValue>[] = [
  { value: PriceGridLadderType.Ladder, displayName: 'Ladder', tooltip: 'Synthetic price at fixed size buckets' },
  { value: PriceGridLadderType.Book, displayName: 'Book', tooltip: 'Raw venue order book depth' },
];

export interface PriceGridLadderControlsProps {
  ladderType: PriceGridLadderTypeValue;
  priceIncrement: string;
  minPriceIncrement: string;
  onLadderTypeChange: (ladderType: PriceGridLadderTypeValue) => void;
  onPriceIncrementChange: (increment: string) => void;
}

export function PriceGridLadderControls({
  ladderType,
  priceIncrement,
  minPriceIncrement,
  onLadderTypeChange,
  onPriceIncrementChange,
}: PriceGridLadderControlsProps) {
  return (
    <HStack gap="spacing8" alignItems="center" data-testid="price-grid-ladder-controls">
      <ToggleGroup
        data-testid="price-grid-ladder-toggle"
        options={LADDER_TYPE_OPTIONS}
        value={ladderType}
        onChange={onLadderTypeChange}
        size={FormControlSizes.Small}
        defaultSelectedVariant={ButtonVariants.Priority}
      />
      {ladderType === PriceGridLadderType.Book ? (
        <PriceIncrement
          min={minPriceIncrement}
          value={priceIncrement}
          onChange={(_index, newIncrement) => onPriceIncrementChange(newIncrement)}
          size={FormControlSizes.Small}
        />
      ) : null}
      <Tour tour={TourName.v71PriceGridLadderToggle} delay={500} />
    </HStack>
  );
}
